var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReduccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 39.1666H44.1667V42.5H37.5V39.1666ZM37.5 25.8333H49.1667V29.1666H37.5V25.8333ZM37.5 32.5H47.5V35.8333H37.5V32.5ZM17.5 42.5C17.5 44.3333 19 45.8333 20.8334 45.8333H30.8334C32.6667 45.8333 34.1667 44.3333 34.1667 42.5V25.8333H17.5V42.5ZM20.8334 29.1666H30.8334V42.5H20.8334V29.1666ZM29.1667 19.1666H22.5L20.8334 20.8333H15.8334V24.1666H35.8334V20.8333H30.8334L29.1667 19.1666Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduccion);
export default __webpack_public_path__ + "static/media/reduccion.5092130402e4911c4bc72cb38dd4b2e1.svg";
export { ForwardRef as ReactComponent };